import React, { useEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { Row, Form, Spinner } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import PayrollCheckRegisterTable, { checkColumns } from './PayrollCheckRegisterTable';
import Excel from '../../../assets/excel.png';
import { Breadcrumbs, Button, EdgeReportingWindow, SubHeader, ReportLoader } from '../../../components';
import { newDateFormatted } from '../../../utils';
import ImageColorChanger from '../../../utils/imageColorChanger';
import getCSVData from '../csv';
import getEdgeReportingMenu from '../getEdgeReportingMenu';
import { userHasAccess, generateReport, getReportData, removeReportData, getList } from '../operations';
import { customStyles, formatSocial } from '../utils';

import './styles.scoped.css';

const PayrollCheckRegisterForm = ({
  setForm,
  form,
  isLoadingBranches,
  isLoadingAMCCodes,
  branches,
  AMCCodes,
  setLoadingResults,
  setData,
  setShowResults,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };

  const handleViewResults = async () => {
    setLoadingResults(true);
    try {
      const response = await generateReport({
        endpoint: 'pay-register-report',
        payload: form,
      });

      if (response.location) {
        const reportData = await getReportData(response.location);
        if (reportData?.length) {
          await removeReportData(response.location);
          setLoadingResults(false);
          setData(reportData);
          setShowResults(true);
        }
      } else {
        // eslint-disable-next-line no-undef
        alert('No data found');
        setLoadingResults(false);
      }
    } catch (error) {
      console.log(error);
      setLoadingResults(false);
    }
    setLoadingResults(false);
  };

  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="filters-row">
        <div
          className="filter-row"
          style={{
            marginTop: '30px',
          }}>
          <Form.Group as={Row} controlId="FromCheckdate" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              <span className="required">Check Date</span>
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="date"
              name="FromCheckdate"
              value={form?.FromCheckdate}
              onChange={handleChange}
              max={form?.ToCheckdate || undefined}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToCheckdate" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
              }}
              as="input"
              type="date"
              name="ToCheckdate"
              value={form?.ToCheckdate}
              onChange={handleChange}
              min={form?.FromCheckdate || undefined}
            />
            <Form.Control.Feedback type="invalid" />
          </Form.Group>
        </div>
        <span style={{ fontWeight: '700' }}>OR</span>
        <div
          className="filter-row"
          style={{
            marginTop: '30px',
          }}>
          <Form.Group as={Row} controlId="FromPerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              <span className="required">Period End Date</span>
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="date"
              name="FromPerEnddate"
              value={form?.FromPerEnddate}
              onChange={handleChange}
              max={form?.ToPerEnddate || undefined}
            />
          </Form.Group>
          <Form.Group as={Row} controlId="ToPerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{
                width: '20px',
                marginLeft: '30px',
                marginRight: '20px',
              }}>
              To
            </Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
              }}
              as="input"
              type="date"
              name="ToPerEnddate"
              value={form?.ToPerEnddate}
              onChange={handleChange}
              min={form?.FromPerEnddate || undefined}
            />
            <Form.Control.Feedback type="invalid" />
          </Form.Group>
        </div>

        <span style={{ fontWeight: '700', margin: '15px 0' }}>
          One or more of the following to refine (not required)
        </span>

        <div className="filter-row">
          <Form.Group as={Row} controlId="EmplLastName" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              {t('edge_reporting.payroll_check_register.driver')} Last Name
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="EmplLastName"
              defaultValue={form?.EmplLastName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="EmplFirstName" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              {t('edge_reporting.payroll_check_register.driver')} First Name
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="EmplFirstName"
              defaultValue={form?.EmplFirstName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>
              {t('edge_reporting.payroll_check_register.driver')} Number
            </Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="EmpId"
              value={form?.EmpId}
              onChange={handleChange}
              type="number"
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="SSNO" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>{t('edge_reporting.payroll_check_register.driver')} SSN</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="SSNO"
              value={formatSocial(form?.SSNO || '')}
              onChange={handleChange}
            />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} controlId="Branch" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Branch</Form.Label>
            <Select
              isDisabled={isLoadingBranches}
              isMulti
              closeMenuOnSelect={false}
              styles={customStyles('360px')}
              options={branches}
              value={form?.Branch?.split(',').map(code => branches.find(option => String(option.value) === code))}
              onChange={selectedOptions => {
                const selectedCodes = selectedOptions.map(option => option.value);
                setForm({
                  ...form,
                  Branch: selectedCodes.join(','),
                });
              }}
            />
            <Spinner
              as="span"
              animation="border"
              size="sm"
              aria-hidden="true"
              className="dropdown-spinner"
              hidden={!isLoadingBranches}
            />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Customer Name</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="CustomerName"
              value={form?.CustomerName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Customer Number</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              type="number"
              as="input"
              name="CustomerNumber"
              value={form?.CustomerNumber}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="AMC" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>AMC</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                styles={customStyles('360px')}
                isDisabled={isLoadingAMCCodes}
                options={AMCCodes}
                isClearable
                onChange={(event, action) => {
                  if (action.action === 'clear') {
                    setForm({
                      ...form,
                      AMC: '',
                    });
                  }
                  if (action.action === 'select-option') {
                    setForm({
                      ...form,
                      AMC: event.value,
                    });
                  }
                }}
                defaultValue={AMCCodes?.filter(option => option.value === form?.AMC)}
              />
              <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
                className="dropdown-spinner"
                hidden={!isLoadingAMCCodes}
              />
            </div>
          </Form.Group>
        </div>
      </div>
      <div className="buttons-row">
        <Button
          variant="primary"
          onPress={handleViewResults}
          style={{ marginRight: '20px', width: '100px' }}
          disabled={!(form?.FromPerEnddate && form?.ToPerEnddate) && !(form?.FromCheckdate && form?.ToCheckdate)}
          text="View"
        />

        <Button
          style={{ width: '100px' }}
          onPress={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

const PayrollCheckRegister = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { menuItems } = getEdgeReportingMenu(t);
  const { user } = useSelector(state => state.admin);
  const [data, setData] = useState([]);
  const [form, setForm] = useState({});
  const [loadingResults, setLoadingResults] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [branches, setBranches] = useState([]);
  const [AMCCodes, setAMCCodes] = useState([]);
  const [isLoadingBranches, setIsLoadingBranches] = useState(false);
  const [isLoadingAMCCodes, setIsLoadingAMCCodes] = useState(false);

  useEffect(() => {
    if (menuItems) {
      // eslint-disable-next-line no-undef
      if (!userHasAccess(user, menuItems.find(i => i.to === window.location.pathname)?.id)) navigate('/');
    }
  }, [menuItems, navigate, user]);

  useEffect(() => {
    handleGetBranches();
    handleGetAmcCodes();
  }, []);

  const handleGetBranches = async () => {
    setIsLoadingBranches(true);
    const branchesResponse = await getList('clients/branches');
    setBranches(
      branchesResponse.map(({ Branch_Code, Branch_Name }) => ({
        label: `${Branch_Name} - ${Branch_Code}`,
        value: Branch_Code,
      })),
    );
    setIsLoadingBranches(false);
  };

  const handleGetAmcCodes = async () => {
    setIsLoadingAMCCodes(true);
    const amcs = await getList('amcs');
    setAMCCodes(
      amcs.map(({ Code, Description }) => ({
        label: Description,
        value: Code,
      })),
    );
    setIsLoadingAMCCodes(false);
  };

  const fileName = `edge-reporting-payroll-check-register-${newDateFormatted.toString()}.csv`;

  return (
    <>
      <SubHeader
        text="EDGE Reporting"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
        }}>
        <Breadcrumbs
          leftTitle="Reporting Home"
          middleTitle={showResults && 'Payroll Check Register'}
          midItemAction={() => setShowResults(false)}
          rightTitle={showResults ? 'Viewing Report' : 'Payroll Check Register'}
          route="/edge-reporting"
        />
        {data?.length && showResults ? (
          <span>
            <CSVLink filename={fileName} data={getCSVData(data, checkColumns)}>
              <ImageColorChanger
                src={Excel}
                style={{ padding: '20px 30px 0 0 ', cursor: 'pointer' }}
                alt="export-to-excel"
              />
            </CSVLink>
          </span>
        ) : null}
      </div>
      {loadingResults && <ReportLoader didAbort={() => setLoadingResults(false)} />}
      {showResults ? (
        <>
          <PayrollCheckRegisterTable data={data} loading={loadingResults} />
          <div className="buttons-row">
            <Button variant="primary" onClick={() => setShowResults(false)} style={{ marginRight: '20px', width: '100px' }} text="Back" />
            <Button
              style={{ width: '100px' }}
              onClick={() => navigate('/edge-reporting')}
              variant="outline"
              text="Cancel"
            />
          </div>
        </>
      ) : (
        <EdgeReportingWindow
          containerStyle={{
            border: '2px solid #343a40',
          }}
          windowContent={
            <PayrollCheckRegisterForm
              form={form}
              setForm={setForm}
              isLoadingBranches={isLoadingBranches}
              isLoadingAMCCodes={isLoadingAMCCodes}
              branches={branches}
              AMCCodes={AMCCodes}
              setLoadingResults={setLoadingResults}
              setData={setData}
              setShowResults={setShowResults}
            />
          }
          windowTitle="Criteria"
          headerStyle={{ backgroundColor: '#343a40' }}
        />
      )}
    </>
  );
};

export default PayrollCheckRegister;
